import * as React from "react";
const SvgAccountHeader = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.4001 15C13.4001 12.7908 10.5347 11 7.0001 11C3.46548 11 0.600098 12.7908 0.600098 15M7.0001 8.59998C4.79096 8.59998 3.0001 6.80911 3.0001 4.59998C3.0001 2.39084 4.79096 0.599976 7.0001 0.599976C9.20924 0.599976 11.0001 2.39084 11.0001 4.59998C11.0001 6.80911 9.20924 8.59998 7.0001 8.59998Z"
    />
  </svg>
);
export default SvgAccountHeader;
